// The things he asked for that have been built (sim world/Asks.js; the
// ask ids are his). Each is a root node ask_<id> in public/models/wants.glb,
// authored in Kiwi_world.blend's 'Wants' collection at world coordinates,
// so the viewer renders the file at identity and shows a want only once its
// ask has been granted. This file is the placement data both sides read:
// where each want stands (at), where he stands to use it (stand), its
// blockers, the boxes that become collision for the sim, so he does not
// walk through a market stall, and for a place he uses sitting down, his
// seat (lib/world/seats.js). Positions are the viewer's (x, y, z); a block
// is an oriented box in the ground plane: centre, half extents along its
// own axes, and its x axis (ax) as an xz direction. A seat is a point, its
// height off the ground (lift) and the way he faces (rotY).
//
// Generated by scripts/blender/wants-sync.py from the blend: move a want by
// its ask_ empty there and run that, rather than nudging numbers here, or
// the model and its data part company. The hilltop picnic spot
// (ask_mun0u3nk) was withdrawn on 6 Oct, Sam's call, for now; it waits in
// the blend's 'Wants withdrawn' collection, out of the export.
// The bakery that opens early (ask_mus052qg) is a building since 7 Oct,
// Sam's, on the street running south from the pizza place (buildings.glb,
// food_bakery_early in the sim), so its sign here went.
//
// Imports nothing.

export const WANTS = {
  ask_muc2q1wq: { key: 'rooftop garden', at: [-58.92, 9.12, 56.85], stand: [-64.12, 0.0, 48.3], blocks: [{ name: 'block_roofstair_1', cx: -64.12, cz: 51.85, hx: 0.6, hz: 2.0, ax: [1.0, 0.0] }] },
  ask_mucn7g1v: { key: 'night market', at: [-75.51, 0.53, 44.08], stand: [-75.51, 0.53, 44.08], blocks: [{ name: 'block_market_1', cx: -71.51, cz: 41.04, hx: 0.7, hz: 1.25, ax: [-0.9944, 0.1056] }, { name: 'block_market_2', cx: -70.96, cz: 46.21, hx: 0.7, hz: 1.25, ax: [-0.9944, 0.1056] }, { name: 'block_market_3', cx: -80.06, cz: 41.95, hx: 0.7, hz: 1.25, ax: [-0.9944, 0.1056] }, { name: 'block_market_4', cx: -79.52, cz: 47.12, hx: 0.7, hz: 1.25, ax: [-0.9944, 0.1056] }] },
  ask_mud5wbnj: { key: 'spray paint', at: [54.3, 0.13, 26.9], stand: null, blocks: [] },
  ask_mued0ydl: { key: 'fresh wall by the salon', at: [55.25, 0.09, 22.0], stand: [53.05, 0.09, 22.0], blocks: [{ name: 'block_wall_1', cx: 55.55, cz: 22.0, hx: 3.7, hz: 0.35, ax: [0.0, 1.0] }] },
  ask_mugjoq9q: { key: 'charging station', at: [43.53, 0.11, 15.43], stand: [43.53, 0.11, 14.33], blocks: [] },
  ask_muharu6m: { key: 'ladder at the dumpster', at: [52.37, 0.0, -12.73], stand: [50.57, 0.0, -12.73], blocks: [] },
  ask_mui1nqvr: { key: 'viewing room for the keys', at: [-22.6, -0.01, -54.75], stand: [-22.6, 0.11, -54.35], blocks: [], seat: { place: 'keyroom', x: -22.6, z: -55.095, lift: 0.65, rotY: 3.1416 } },
  ask_mum6mkme: { key: 'rooftop greenhouse', at: [-57.01, 9.12, 61.3], stand: null, blocks: [] },
  ask_muo646ys: { key: 'observation deck', at: [-60.22, 9.12, 52.2], stand: null, blocks: [] },
  ask_musd447c: { key: 'bench near the shrine', at: [-14.79, 0.01, 1.56], stand: [-13.89, 0.01, 1.56], blocks: [], seat: { place: 'bench', x: -14.686, z: 1.556, lift: 0.85, rotY: 1.5708 } },
  ask_musqbd69: { key: 'soup cart', at: [81.71, -0.01, 33.83], stand: [81.71, -0.01, 35.33], blocks: [{ name: 'block_soup_1', cx: 81.71, cz: 33.73, hx: 1.3, hz: 0.7, ax: [1.0, 0.0] }] },
  ask_muuvy5hl: { key: 'shelter by the shrine', at: [-5.62, 0.28, 29.19], stand: [-5.92, 0.28, 28.94], blocks: [] },
  ask_mve1weuy: { key: 'vending machine', at: [111.5, 0.04, 22.6], stand: [111.5, 0.04, 24.55], blocks: [{ name: 'block_vending_1', cx: 111.5, cz: 22.6, hx: 0.94, hz: 0.71, ax: [1.0, 0.0] }] },
}

/** The want for an ask id, or null. */
export function wantFor(askId) {
  return WANTS[String(askId || '')] || null
}

/** Every blocker of the wants whose asks are in `granted` (a Set of ids), or all of them. */
export function wantBlocks(granted = null) {
  const out = []
  for (const [ask, w] of Object.entries(WANTS)) {
    if (granted && !granted.has(ask)) continue
    for (const b of w.blocks) out.push({ ...b, ask })
  }
  return out
}
